import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EpdkSnackBarModule } from '@epdk/ui/snack-bar';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatSnackBarModule,

    EpdkSnackBarModule
  ]
})
export class SnackBarServiceModule { }
